import React from "react";
import { aboutSections, team } from "../mock";
import { Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import MVV from "../components/MVV";
import useSeo from "../hooks/useSeo";

const About = () => {
  useSeo({
    title: "About Us",
    description:
      "Meet the Astoria Solutions team — a knowledge-led firm blending research rigor, financial acumen and delivery discipline for measurable client outcomes.",
    path: "/about",
  });
  return (
    <>
      <section className="bg-black text-white">
        <div className="max-w-7xl mx-auto px-6 py-20 text-center">
          <h1 className="text-4xl md:text-6xl font-extrabold">About Us</h1>
          <p className="mt-4 text-teal-400">Dedicated to authenticity, history, and heritage preservation.</p>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-extrabold text-neutral-900">About ASTORIA SOLUTIONS</h2>
            <p className="mt-4 text-neutral-600">
              Blending research, finance, and auction innovation into one powerful enterprise.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
            {aboutSections.map((s, i) => (
              <div
                key={i}
                className="bg-neutral-50 rounded-2xl p-8 border border-neutral-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-10 h-1 bg-teal-500 rounded-full" />
                <h3 className="mt-4 text-xl font-bold text-neutral-900">{s.title}</h3>
                <p className="mt-3 text-neutral-600 leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TEAM */}
      <section className="bg-neutral-50 py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-2xl mx-auto">
            <p className="text-teal-500 font-bold tracking-widest text-sm">LEADERSHIP</p>
            <h2 className="mt-2 text-3xl md:text-4xl font-extrabold text-neutral-900">Meet the people behind Astoria</h2>
            <p className="mt-3 text-neutral-600">A tight team of specialists blending research rigor, financial acumen and delivery discipline.</p>
          </div>
          <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {team.map((m) => (
              <Link
                key={m.slug}
                to={`/team/${m.slug}`}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border border-neutral-100 block"
              >
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img src={m.image} alt={m.role} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <span
                    aria-label={`LinkedIn ${m.role}`}
                    className="absolute bottom-3 right-3 w-9 h-9 rounded-full bg-white/95 flex items-center justify-center text-neutral-700 group-hover:text-teal-600 transition-colors shadow"
                  >
                    <Linkedin className="w-4 h-4" />
                  </span>
                </div>
                <div className="p-4">
                  <div className="text-[10px] tracking-widest font-bold text-teal-600">{m.department.toUpperCase()}</div>
                  <h3 className="mt-1 font-bold text-neutral-900 group-hover:text-teal-600 transition-colors leading-tight">{m.role}</h3>
                  <p className="mt-2 text-xs text-neutral-600 leading-relaxed">{m.bio}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <MVV />
    </>
  );
};

export default About;
